import './assets/tailwind.css'
import './registerServiceWorker'

import Vue from 'vue'
import Toasted from 'vue-toasted'
import Paginate from 'vuejs-paginate'
import Vuelidate from 'vuelidate'

import App from './App.vue'
import clickAwayDirective from './directives/clickAway.directive'
import { dateFilter } from './filters/date.filter'
import i18nFilter from './filters/i18n.filter'
import router from './router'
import store from './store'
import axiosPlugin from './utils/axios.plugin'
import configPlugin from './utils/config.plugin'
import loggerPlugin from './utils/logger.plugin'

Vue.config.productionTip = false

Vue.use(axiosPlugin)
Vue.use(configPlugin)
Vue.use(loggerPlugin)
Vue.use(Vuelidate)
Vue.use(Toasted, {
  duration: 3000,
  keepOnHover: true
})
Vue.filter('date', dateFilter)
Vue.filter('i18n', i18nFilter)
Vue.directive('click-away', clickAwayDirective)
Vue.component('Paginate', Paginate)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
